<template>
  <div class="activity-detail">
    <div class="activity-main">
      <div class="location">
        <img :src="require('../../assets/img/location.png')" alt="">
        当前位置：
        <template v-for="(item, index) in pathList">
          <span :key="index" class="location-name" @click="$router.push(item.path)">{{ item.name }}  </span> >
        </template>
        活动详情
      </div>
      <div class="activity-content">
        <img v-if="detailData.coverImg" :src="$urlPrefix + detailData.coverImg" alt="">
        <div v-else class="coverArea" style="width: 362px;height: 252px">
          <p style="font-size: 20px;line-height: 35px">{{ detailData.activityTitle }}</p>
        </div>
        <div class="detail-info">
          <div class="title">
            <div class="type" style="backgroundColor: '#F69F60'">{{ themeMapping[detailData.activityTheme] }}</div>
            <div class="type" :style="{backgroundColor: $typeColorMapping[detailData.activityType]}"> {{ $typeMapping[detailData.activityType] }}</div>
            {{ detailData.activityTitle }}
          </div>
          <div class="gray-area">
            <p class="sponsor">
              主&nbsp;&nbsp;办&nbsp;方: &nbsp;&nbsp;
              <el-tooltip effect="light" placement="top" :content="detailData.sponsor">
                <span>{{ detailData.sponsor }}</span>
              </el-tooltip>
            </p>
            <p class="time">活动时间: &nbsp;&nbsp;{{ detailData.startTime }} - {{ detailData.endTime }}</p>
            <p class="address">活动地点: &nbsp;&nbsp;
              <el-tooltip effect="light" placement="top" :content="detailData.activityAddress">
                <span>{{ detailData.activityAddress }}</span>
              </el-tooltip>
            </p>
            <p class="bottom">
              限制人数:&nbsp;&nbsp;<span>{{ detailData.peopleNum }}人</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              当前报名人数:&nbsp;&nbsp;<span>{{ detailData.applyNum }}人</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              浏览量:&nbsp;&nbsp;<span>{{ detailData.pageView }}</span>
              <span style="float: right;" :style="{color: isCollected === 'confirm' ? '#EA5504' : '#999999'}" @click="collect"><i class="el-icon-star-on" style="font-size: 25px;vertical-align: top" />收藏</span>
            </p>
          </div>
        </div>
        <div v-if="detailData.process" class="process" :style="{backgroundColor: $processMapping[detailData.process].color}">{{ $processMapping[detailData.process].name }}</div>
        <img v-if="detailData.process === 4" class="has-held" :src="require('../../assets/img/hasHeld.png')" alt="">
        <div style="margin-top: 30px; text-align: initial" v-html="detailData.activityContent" />
        <div v-if="detailData.process === 2" class="toJoin" @click="toJoin">我要参加
          <template v-if="detailData.preferentialPrice || detailData.preferentialPrice === 0">
            ( {{ detailData.preferentialPrice === 0 ? '免费' : '￥' + detailData.preferentialPrice + '元' }} )
          </template>
          <template v-else-if="detailData.originPrice > 0">
            ( ￥{{ detailData.originPrice }}元 )
          </template>
          <template v-else>
            ( 免费 )
          </template>
        </div>
      </div>
    </div>

    <el-dialog class="join-dialog" title="活动火热报名中" width="905px" :visible.sync="joinDialogShow">
      <div class="notice">最多报名3人</div>
      <p style="width: 520px;position: relative">
        <span><i class="red-star">*</i>&nbsp;&nbsp;公司名称：</span><br>
        <el-autocomplete
            v-model="joinParams.companyName"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            style="width: 100%"
            @select="handleChangeAuto"
        ></el-autocomplete>
        <el-select
            v-if="false"
          v-model="joinParams.companyName"
          filterable
          remote
          reserve-keyword
          @change="handleChange"
          style="width: 100%"
          :remote-method="remoteMethod"
          :loading="loading">
          <el-option
            v-for="item in options"
            :key="item.company_code"
            :label="item.company_name"
            :value="item.company_name">
          </el-option>
        </el-select>
      </p>
      <p style="margin-right: 0;width: 250px;position: relative">
        <span><i class="red-star">*</i>&nbsp;&nbsp;社会信用代码：</span><br>
        <el-input v-model="joinParams.socialCreditCode" />
      </p>
      <div v-for="(item, index) in joinParams.applyUserList" :key="index" class="join-people">
        <p v-for="(value, key) in item" :key="key" class="join-item">
          <span><i class="red-star">*</i>&nbsp;&nbsp;{{ joinParamMapping[key] }}：</span><br>
          <el-input v-model="item[key]" @change="errorPhone = []" :class="{cellPhoneInput: key === 'cellPhone' && errorPhone.includes(index)}" />
        </p>
        <i v-if="joinParams.applyUserList.length < 3" class="el-icon-circle-plus" style="color: #13CE66" @click="addJoinPeople" />
        <i v-if="index !== 0" class="el-icon-remove" style="color: #F4516C;margin-left: 5px" @click="removeJoinPeople(index)" />
      </div>
      <div class="submit-button" @click="handleSubmit">提交报名</div>
    </el-dialog>
  </div>

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ActivityDetail',
  data() {
    return {
      errorPhone: [],
      pathList: [],
      currentPathList: [],
      themeMapping: [],
      options: [],
      loading: false,
      isCollected: false,
      joinParamMapping: {
        'duty': '职务',
        'userName': '联系人',
        'cellPhone': '联系电话'
      },
      joinDialogShow: false,
      joinParams: {
        companyName: '',
        socialCreditCode: '',
        applyUserList: [
          {
            duty: '',
            userName: '',
            cellPhone: ''
          }
        ]
      },
      companyInfo: {
        companyName: '',
        socialCreditCode: ''
      },
      detailData: {},
      fromPath: {
        topName: '',
        topPath: '',
        path: '',
        pathPkid: '',
        name: ''
      }
    }
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    if (this.$route.query.pathList) {
      this.pathList = JSON.parse(this.$route.query.pathList)
      this.pathList = this.pathList.filter(item => item.name !== '活动详情')
      this.currentPathList = JSON.stringify([...this.pathList, {
        name: '活动详情',
        path: this.$route.fullPath
      }])
    }
    if (this.token) {
      this.getCollectStatus()
      this.getCompanyInfo()
    }
    if (localStorage.getItem('themeMapping')) {
      this.themeMapping = JSON.parse(localStorage.getItem('themeMapping'))
    }
    this.fetchData()
  },
  methods: {
    handleChange(data) {
      if (this.options.length > 0) {
        this.options.forEach(item => {
          if (item.company_name === data) {
            this.joinParams.socialCreditCode = item.company_code
          }
        })
      }
    },
    querySearchAsync(queryString, cb) {
      if (!['', null, undefined].includes(queryString)) {
        this.loading = true
        this.$get('/front/index/selectCompany', queryString).then(res => {
          this.loading = false
          this.options = res.data
          const _t = JSON.parse(JSON.stringify(res.data))
          const __t = _t.map(i => {
            return {
              value: i.company_name || ''
            }
          })
          cb(__t)
        })
      } else {
        this.loading = false
      }
    },
    handleChangeAuto(data) {
      console.log('choose', data)
      data = data.value
      if (this.options.length > 0) {
        this.options.forEach(item => {
          if (item.company_name === data) {
            this.joinParams.socialCreditCode = item.company_code
          }
        })
      }
    },
    remoteMethod(keywords) {
      this.loading = true
      this.$get('/front/index/selectCompany', keywords).then(res => {
        this.loading = false
        this.options = res.data
      })
    },
    getCollectStatus() {
      const param = {
        sourcePkid: this.$route.query.pkid,
        collectType: 'activity'
      }
      this.$post('/front/index/collectStatus', param).then(res => {
        this.isCollected = res
      })
    },
    getCompanyInfo() {
      this.$post('/front/userCenter/companyInfo', {}).then(res => {
        if (res) {
          this.companyInfo = {
            companyName: res.companyName,
            socialCreditCode: res.socialCreditCode
          }
        }
      })
    },
    fetchData() {
      this.$get('/front/index/activityInfo', this.$route.query.pkid).then(res => {
        if (res) {
          if (this.$getNow < res.applyStartTime) {
            res.process = 1
          } else if (this.$getNow >= res.applyStartTime && this.$getNow <= res.applyEndTime) {
            res.process = 2
          } else if (this.$getNow < res.startTime && this.$getNow > res.applyEndTime) {
            res.process = 3
          } else if (this.$getNow >= res.startTime && this.$getNow <= res.endTime) {
            res.process = 4
          } else if (this.$getNow > res.endTime) {
            res.process = 5
          }
          this.detailData = res
        }
      })
    },
    handleSubmit() {
      if (this.joinParams.companyName === '') {
        return this.$message.warning('请填写公司名称 !')
      }
      if (this.joinParams.socialCreditCode === '') {
        return this.$message.warning('请填写社会信用统一代码 !')
      }
      if (this.joinParams.applyUserList) {
        const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
        for (let i = 0; i < this.joinParams.applyUserList.length; i++) {
          if (!this.joinParams.applyUserList[i].userName || !this.joinParams.applyUserList[i].duty || !this.joinParams.applyUserList[i].cellPhone) {
            return this.$message.warning('请完善报名人信息 !')
          }
          if (!reg.test(this.joinParams.applyUserList[i].cellPhone)) {
            this.errorPhone.push(i)
          }
        }
        if (this.errorPhone.length > 0) {
          return this.$message.warning('请输入正确的联系电话 !')
        }
      }
      this.$post('/front/index/applyActivity', this.joinParams).then((res) => {
        if (res) {
          this.joinDialogShow = false
          this.$message.success(res)
        }
      })
    },
    addJoinPeople() {
      this.joinParams.applyUserList.push({
        duty: '',
        userName: '',
        cellPhone: ''
      })
    },
    removeJoinPeople(index) {
      this.joinParams.applyUserList.splice(index, 1)
    },
    collect() {
      if (!this.token) {
        return this.$message.warning('请先登录 !')
      }
      let text
      this.isCollected === 'confirm' ? text = '确定取消收藏该活动 ?' : text = '确定收藏该活动 ?'
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const param = {
          sourcePkid: this.$route.query.pkid,
          collectType: 'activity',
          action: this.isCollected === 'confirm' ? 'cancel' : 'confirm'
        }
        this.$post('/front/index/collect', param).then(res => {
          if (res) {
            this.isCollected = this.isCollected === 'confirm' ? 'cancel' : 'confirm'
          }
        })
      })
    },
    toJoin() {
      this.joinParams = {
        activityPkid: this.$route.query.pkid,
        companyName: this.companyInfo.companyName,
        socialCreditCode: this.companyInfo.socialCreditCode,
        applyUserList: [
          {
            duty: '',
            userName: '',
            cellPhone: ''
          }
        ]
      }
      this.joinDialogShow = true
    }
  }
}
</script>
<style lang="scss">
.activity-detail {
  .join-dialog {
    .notice {
      width: 100%;
      height: 45px;
      line-height: 20px;
      text-align: center;
      color: #FF4040;
      font-size: 16px
    }
    .el-dialog {
      width: 750px;
      .el-dialog__header {
        text-align: center;
        .el-dialog__title {
          font-size: 24px;
          color: #EA5504;
        }
      }
      .el-dialog__body {
        padding-top: 0;
        .red-star {
          position: absolute;
          font-size: 15px;
          font-weight: 600;
          color: red;
          top: 0;
          left: 0;
        }
        .join-people {
          i {
            font-size: 24px;
          }
          .join-item {
            position: relative;
            width: 250px;
            .red-star {
              font-size: 15px;
              font-weight: 600;
            }
          }
        }
        p {
          display: inline-block;
          width: 310px;
          margin: 0 20px 10px 0;
          span {
            font-size: 18px;
            font-weight: 400;
            color: #333333;
          }
          .el-input {
            width: 100%;
            height: 36px;
            background: #FFFFFF;
            border-radius: 10px;
            margin-top: 10px;
            .el-input__inner {
              height: 36px;
              border: 1px solid #999999;
              border-radius: 10px;
              font-size: 16px;
              font-weight: 400;
              color: #333333;
              padding: 0 10px;
            }
          }
          .el-input.cellPhoneInput {
            .el-input__inner {
              border: 1px solid red;
            }
          }
          input:focus {
            border: 1px solid #EA5504 !important;
          }
        }
        .submit-button {
          width: 120px;
          height: 40px;
          line-height: 40px;
          margin: 10px auto 0 auto;
          background: #EA5504;
          border-radius: 2px;
          text-align: center;
          font-size: 18px;
          color: #FFFFFF;
          cursor: pointer;
        }
        .submit-button:hover {
          opacity: 0.8;
        }
      }
    }
  }

}
</style>
<style lang="scss" scoped>
.activity-detail {
  background-color: #F6F6F5;
  padding: 30px 0;
  .activity-main {
    width: 1200px;
    min-height: 900px;
    margin: 0 auto;
    .location {
      width: 1200px;
      font-size: 14px;
      font-weight: 400;
      color: #363942;
      margin: 0 auto 25px auto;
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
      .location-name {
        cursor: pointer;
        color: darkgray;
      }
      .location-name:hover {
        color: #EA5504;
      }
    }
  }
  .activity-content {
    position: relative;
    width: 1200px;
    background-color: #FFFFFF;
    padding: 30px;
    overflow: hidden;
    box-sizing: border-box;
    img {
      display: inline-block;
      width: 362px;
      height: 252px;
      border-radius: 6px;
      vertical-align: top;
    }
    .detail-info {
      display: inline-block;
      width: 755px;
      margin-left: 20px;
      .title {
        display: -webkit-box;
        width: 725px;
        height: 70px;
        margin-top: -10px;
        font-size: 22px;
        font-weight: bold;
        color: #363942;
        line-height: 36px;
        overflow: hidden;
        text-overflow: ellipsis ;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
        .type {
          display: inline-block;
          width: 80px;
          height: 24px;
          line-height: 24px;
          background: #F69F60;
          margin-right: 10px;
          border-radius: 5px;
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          text-align: center;
          vertical-align: middle;
        }
      }
      .gray-area {
        width: 755px;
        height: 170px;
        margin-top: 15px;
        background: #F2F3F8;
        padding: 12px 20px;
        box-sizing: border-box;
        p {
          width: 100%;
          font-size: 14px;
          font-weight: bold;
          color: #363942;
          line-height: 25px;
          overflow: hidden;
          text-overflow: ellipsis ;
          white-space: nowrap;
        }
        .bottom {
          font-weight: 400;
          color: #A2A8B6;
          margin-top: 45px;
          span {
            color:#EA5504;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;
          }
          span:hover {
            color:#EA5504;
          }
        }
      }
    }
    .process {
      position: absolute;
      top: -60px;
      right: -60px;
      width: 120px;
      height: 120px;
      background-color: #0AC18F;
      font-size: 18px;
      text-align: center;
      color: #FFFFFF;
      line-height: 200px;
      transform: rotate(45deg);
      z-index: 10;
    }
    .has-held {
      position: absolute;
      top: 50px;
      right: 50px;
      width: 262px;
      height: 140px;
    }
    .toJoin {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background-color: #EA5504;
      border-radius: 10px;
      font-size: 18px;
      text-align: center;
      color: #FFFFFF;
      cursor: pointer;
      margin: 50px auto 0 auto;
    }
    .toJoin:hover {
      opacity: 0.8;
    }
  }
}

</style>
